import AntiforgeryService from './anti-forgery.service';

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

export default class ApiClientService {
  public static get<T>(url: string, signal?: AbortSignal): Promise<T> {
    return ApiClientService.send<T>('GET', url, undefined, signal);
  }

  public static post<T>(url: string, body?: unknown, signal?: AbortSignal): Promise<T> {
    return ApiClientService.send<T>('POST', url, body, signal);
  }

  public static put<T>(url: string, body?: unknown, signal?: AbortSignal): Promise<T> {
    return ApiClientService.send<T>('PUT', url, body, signal);
  }

  public static delete<T = void>(url: string, signal?: AbortSignal): Promise<T> {
    return ApiClientService.send<T>('DELETE', url, undefined, signal);
  }

  private static async send<T>(method: HttpMethod, url: string, body: unknown, signal: AbortSignal | undefined): Promise<T> {
    const headers: Record<string, string> = { 'X-Requested-With': 'XMLHttpRequest' };
    if (method !== 'GET') headers['X-XSRF-TOKEN'] = await AntiforgeryService.getToken();
    if (body !== undefined) headers['Content-Type'] = 'application/json';
    const serializedBody = body === undefined ? undefined : JSON.stringify(body);

    let response: Response;
    try {
      response = await fetch(url, { method, headers, body: serializedBody, signal });
    } catch (error) {
      if (signal?.aborted) throw error;
      throw Object.assign(new Error('Network request failed'), { name: 'NetworkError' });
    }

    if (!response.ok) throw Object.assign(new Error('HTTP request failed'), { statusCode: response.status });
    if (response.status === 204) return undefined as T;
    return (await response.json()) as T;
  }
}
